/**
 * Validates a prop value against a list of valid values.
 *
 * @param {Object} params - The parameters for the function.
 * @param {string} params.componentName - The name of the component.
 * @param {string} params.propName - The name of the prop.
 * @param {string} params.propValue - The value of the prop.
 * @param {Array.<string>} params.validPropValues - The list of valid prop values.
 */
function validatePropValue({ componentName, propName, propValue, validPropValues }) {
  if (!validPropValues.includes(propValue)) {
    /* eslint-disable no-console */
    console.error(
      `[${componentName} ERROR] "${propValue}" is not a supported ${propName} value. Must be one of: ${validPropValues.join(
        " "
      )}`
    );
  }
}

/** Validates an object prop value with a schema.
 * @param {Object} params - The parameters for the function.
 * @param {string} params.componentName - The name of the component.
 * @param {string} params.propName - The name of the prop.
 * @param {Object} params.propValue - The value of the prop.
 * @param {Object} params.schema - The schema for the prop validation.
 */

function validatePropObjectWithSchema({ componentName, propName, propValue, schema }) {
  Object.keys(schema).forEach((key) => {
    if (schema[key] === "array" && !Array.isArray(propValue[key])) {
      /* eslint-disable no-console */
      console.error(
        `[${componentName} ERROR] "${propValue[key]}" is not a supported ${propName} value for ${key} property. Must be an array`
      );
    } else if (schema[key] !== "array" && propValue[key] && typeof propValue[key] !== schema[key]) {
      /* eslint-disable no-console */
      console.error(
        `[${componentName} ERROR] "${propValue[key]}" is not a supported ${propName} value for ${key} property. Must be a(n) ${schema[key]}`
      );
    }
  });
}

export { validatePropValue, validatePropObjectWithSchema };
